export const links: string[] = [
  'bodytech://app/bt',
  'bodytech://app/agenda',
  'bodytech://app/favoritos',
  'bodytech://app/treinos',
  'bodytech://app/mgm',
  'bodytech://app/pass',
  'bodytech://app/academia/<slug>',
];
